<div >
    <div class="flex justify-center align-middle flex-col mt-36">
        <mat-card class="max-w-[35rem] min-w-[35rem] text-center self-center">

            <h1 class="text-center text-[16px] lg:text-[20px] text-[#1a1a1a]">{{"profile verification" | translate}}</h1>
            <mat-card-header class="m-4">
            </mat-card-header>
            
            <img  src="../../../assets/image/logo-black.png"><br>
            <mat-card >
                <mat-label *ngIf="verified==1" class="info-txt"><span class="iconify" data-icon="akar-icons:circle-check" data-width="74">
                    </span>
                    {{"Your profile has successfuly been verificated, please set a new password!" | translate}}
                </mat-label>
                <mat-label *ngIf="verified==0" class="info-txt">
                    <span class="iconify" data-icon="akar-icons:circle-x" data-width="34"></span>
                    {{"Verification failed!" | translate}}
                </mat-label>
                <mat-label *ngIf="verified==2" class="info-txt">
                    <span class="iconify" data-icon="akar-icons:circle-x" data-width="34"></span>
                    {{"The verification link is expired!" | translate}}
                </mat-label>
            </mat-card>
            <div *ngIf="verified==1" class="toregister">
                <a routerLink="../verification-code/{{key}}/{{email}}/{{code}}">{{"set new password" | translate}}</a><br>
            </div>
        </mat-card>
    </div>
</div>
